import httpClient from '../../shared/services/httpClient';

interface PaymentStatusResponse {
  placeId: number;
  status: string;
  plan: string;
  invoiceUrl: string;
}

export const PaymentStatus = async (placeId: number): Promise<PaymentStatusResponse> => {
  const response = await httpClient.get(`/payments/status?placeId=${placeId}`);
  return response.data;
};
